<template>
  <div>
    <div
      class="px-4 sm:px-6 md:px-8 mb-8 flex items-center justify-between flex-wrap sm:flex-no-wrap"
    >
      <div>
        <h1 class="text-2xl font-semibold text-gray-900">Vidéos</h1>
      </div>
      <div class="flex-shrink-0"></div>
    </div>

    <div class="mx-auto px-4 sm:px-6 md:px-8 mt-4">
      <div class="flex flex-col">
        <div
          class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
        >
          <div class="bg-white shadow overflow-hidden sm:rounded-md">
            <div
              class="bg-white px-4 py-3 flex items-center justify-end border-b border-gray-200 sm:px-6"
            >
              <div class="flex">
                <div class="rounded-md shadow-sm">
                  <select
                    v-model="period"
                    id="period"
                    class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 max-w-2xs"
                  >
                    <option value="all">Tous</option>
                    <option value="day">Jour</option>
                    <option value="week">Semaine</option>
                    <option value="month">Mois</option>
                  </select>
                </div>
              </div>
            </div>

            <div
              class="bg-white shadow overflow-hidden sm:rounded-md"
              v-if="hasVideos"
            >
              <ul>
                <video-preview
                  v-for="video in currentPaginateVideos"
                  :key="video.id"
                  :video="video"
                ></video-preview>
              </ul>
            </div>
            <div
              class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VideoPreview from "@/components/Videos/VideoPreview";
export default {
    components: {
        VideoPreview
    },
    data() {
        return {
            page: 1,
            period: "all"
        };
    },
    computed: {
        ...mapGetters("video", ["videos", "currentPaginateVideos"]),
        hasVideos() {
            return this.currentPaginateVideos
                ? this.currentPaginateVideos.length > 0
                : false;
        }
    },
    methods: {
        getVideos() {
            this.$store
                .dispatch("video/get", {
                    "page[number]": this.page,
                    period: this.period === "all" ? null : this.period
                })
                .then(({ data }) => {
                    console.log(data);
                });
        }
    },
    watch: {
        page() {
            this.getVideos();
        },
        period() {
            this.getVideos();
        }
    }
};
</script>
